export const auth = {
  loginTitle: 'Sign in',
  loginSubtitle: 'Access NT Academy with your corporate account.',
  tagline: 'NTConsult’s learning platform.',
  signInWithMicrosoft: 'Sign in with Microsoft',
  useCorporateAccount: 'Use your NT corporate account.',
  errorAuthFailedTitle: 'Could not sign you in.',
  errorAuthFailedDescription: 'Please try again. If it persists, contact IT support.',
  errorAccountInactiveTitle: 'Your account is inactive.',
  errorAccountInactiveDescription:
    'Contact HR or the NT Academy administrator to reactivate your access.',
  callbackPending: 'Finishing sign-in...',
  logout: 'Sign out',
  logoutConfirmTitle: 'Sign out of your account?',
  logoutConfirmDescription: 'You will need to sign in again to continue.',
  profile: {
    title: 'My profile',
    identity: 'Identity',
    roles: 'Roles',
    rolesHint: 'Roles are granted by the administrator.',
    adminBadge: 'Admin',
    shortcuts: 'Shortcuts',
    myCertificates: 'My certificates',
  },
} as const;
